import React from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import WeImg from '../../assets/images/side_knife_img.svg'
import WeIcon from '../../assets/images/knife_icon.png'
import Weimg from '../../assets/images/who_we.webp'
import Wechef from '../../assets/images/who_chef_home.webp'
// import Wetext from '../../assets/images/who_text.png'
import gallery01 from '../../assets/images/gallery_01.webp'
import gallery02 from '../../assets/images/gallery_02.webp'
import gallery03 from '../../assets/images/gallery_03.webp'
import gallery04 from '../../assets/images/gallery_04.webp'
import gallery05 from '../../assets/images/gallery_05.webp'
import gallery06 from '../../assets/images/gallery_06.webp'
import gallery07 from '../../assets/images/gallery_07.webp'
import gallery08 from '../../assets/images/gallery_08.webp'

const Whoslider = {
  infinite: true,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        centerMode: true,
        lazyLoad: 'progressive',
        slidesToShow: 10,
        autoplaySpeed: 800,
        edgeFriction: 25,
        initialSlide: 1,
        easing: "linear"

      },
    },
    {
      breakpoint: 1000,
      settings: {
        centerMode: true,
        lazyLoad: 'progressive',
        slidesToShow: 5,
        autoplaySpeed: 800,
        edgeFriction: 25,
        initialSlide: gallery01,
        easing: "linear"
      },
    },
  ],
}

function WhoWe() {
  return (
    <>
      <div className="row_am who_we_section bg_white_textcher">
        <div className="sider_shape" data-aos="fade-in" data-aos-duration={1500}>
          <img src={WeImg} alt="img" />
        </div>
        <div className="container">
          <div className="section_title d-flex justify-content-center align-items-start" data-aos="fade-up" data-aos-duration={1500} >
            <div className="icon">
              <img src={WeIcon} alt="img" />
            </div>
            <div className="text">
              <span className="sub_text">Who we are</span>
              <h2>
              Get ready for a taste sensation at ARMAYA!<br /> Indulge in Unmatched Flavors{" "}
              </h2>
            </div>
          </div>
          <div className="row row_am">
            <div className="col-md-6">
              <div className="img" data-aos="fade-up" data-aos-duration={1500}>
                <img className="img-fluid radius_img" src={Weimg} alt="img" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="who_We_text">
                <p data-aos="fade-up" data-aos-duration={1500}>
                ARMAYA: Delicious & Unique!
ARMAYA serves amazing food unlike anywhere else. Our menu has special dishes you won't find anywhere else, with both international flavors and traditional Indian tastes.  It's a delicious adventure!
                </p>
                <div className="chef_block d-flex justify-content-center align-items-center" data-aos="fade-up" data-aos-duration={1500} >
                  <img className="chef_img" src={Wechef} alt="img" />
                  {/* <img className="text_img" src={Wetext} alt="img" /> */}
                </div>
                <div className="action_block" data-aos="fade-up" data-aos-duration={1500} >
                  <ul className="social_media d-flex align-content-center">
                    <li>
                      <Link to="#">
                        <i className="icofont-facebook" />
                      </Link>
                    </li>
                    <li>
                      {/* <Link to="#">
                        <i className="icofont-twitter" />
                      </Link> */}
                    </li>
                    <li>
                      <Link to="https://www.instagram.com/armaya_1011" target='_blank'> 
                        <i className="icofont-instagram" />
                      </Link>
                    </li>
                    <li>
                      {/* <Link to="#">
                        <i className="icofont-pinterest" />
                      </Link> */}
                    </li>
                  </ul>
                  <Link to="/contact" className="btn btn_primary">
                    Get direction <i className="icofont-location-pin" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="gallery_direction_right gallery_slider"  style={{ marginLeft: '-165px' }}>
          <Slider className="Slider-Who" {...Whoslider} id="gallery_flow_right" data-aos="fade-in" data-aos-duration={1500} slidesToShow={11.5} arrows={false} autoplay={true} autoplaySpeed={1000}>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery01} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery02} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery03} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery04} alt="img" />
              </div>
            </div>
          </Slider>
          <Slider className='Slider-Who'{...Whoslider} id="gallery_flow_left" data-aos="fade-in" data-aos-duration={1500}  rtl={true} slidesToShow={11.5} arrows={false} autoplay={true} autoplaySpeed={1000} >
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery05} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery06} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery07} alt="img" />
              </div>
            </div>
            <div className="item">
              <div className="img">
                <img src={gallery08} alt="img" />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  )
}

export default WhoWe